/**
 * Búsqueda de texto del lado del cliente, alineada con `domain/busqueda.py`
 * del backend: minúsculas y sin acentos, para que «Alvarez» encuentre a
 * «Álvarez» igual que lo hace `GET /api/casos?q=` del lado del servidor.
 *
 * La usa el buscador del Panel (filtra en memoria los casos activos ya
 * cargados). Si el listado de Casos cambia qué columnas busca, este es el
 * espejo que hay que ajustar para que las dos cajas de búsqueda no diverjan.
 */
export function normalizarBusqueda(s: string): string {
  return s
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .trim();
}

/** True si el query normalizado aparece en alguno de los campos (ignora vacíos). */
export function textoCoincide(query: string, ...campos: Array<string | null | undefined>): boolean {
  const q = normalizarBusqueda(query);
  if (!q) return true;
  return campos.some((c) => !!c && normalizarBusqueda(c).includes(q));
}
